export const notificationAdminFields = {
  ID: 'id',
  FILE_ID: 'fileId',
  LEGAL_ENTITY_NAME: 'legalEntityName',
  PERIOD: 'period',
  FILE_URL: 'path',
};
